// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Comme-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face{
  font-family: 'Storkdle';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: normal;
  font-style: normal;
}

.App {
  text-align: center;
  background-color: #3b3b3b;
  font-family: 'Storkdle', sans-serif;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.word{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  
  height: 60px;
  -webkit-user-select: none;
          user-select: none;
  /*
  background-color: #61dafb;
  border-style: double;
  border-width: 1px;
  margin: 5px;
  */
}

@keyframes bounce {
  from{ 
    max-height: 50px;
  }
  to{
    max-height: 0px;
  }
}

.letterBox {
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 1.5rem;
  font-weight: 5;
  text-align: center;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-left: 5px;
  max-width: 50px;
  max-height: 50px;
  aspect-ratio: 1;
  position:relative;

  outline-width: 1px;
  outline-style: solid;
  color: #131313;
  background: #e7edf3;
/*
  animation-name: bounce;
  animation-iteration-count: infinite;
  animation-duration: 2s;
  animation-direction: normal;
  animation-timing-function: linear;
*/


}

@keyframes popScale {
  from{
    scale: 1.0;
  }
  to{
    scale: 1.1;
  }
}

@keyframes onInvalidWord {
  from{
    background: #e7edf3;
    color: #131313;
  }
  to{
    background: #9c0000;
    color: #c3c3c3;
  }
}
@keyframes onGuess {
  from{
    font-size: 0rem;
  }
  to{
    font-size: 1.5rem;
  }
}

.letterBox[state='invalid']{
  color: #c3c3c3;
  background: #9c0000;
  outline-color: #212121;
  animation-name: popScale, onInvalidWord;
  animation-duration: 0.1s, 0.1s;
  animation-direction: alternate-reverse, normal;
  animation-iteration-count: 1, 1;
}

.letterBox[state="valid"]{
  color: #131313;
  background: #e7edf3;
  outline-color: #212121;

  animation-name: popScale;
  animation-duration: 0.05s;
  animation-direction: alternate-reverse;
  animation-iteration-count: 1;
}
.letterBox[state="incomplete"]{
  color: #131313;
  background: #e7edf3;
  outline-color: #acacac;
}
.letterBox[state="unused"]{
  color: #131313;
  background: #e7edf3;
  outline-color: #acacac;
}


.letterBox[type="result"]{
  background: #414141;
  animation-name: bounce, onGuess;
  animation-duration: 0.1s, 0.1s;
  animation-direction: alternate-reverse, normal;
  animation-iteration-count: 1, 1;
}

.letterBox[state="noMatch"]{
  color: #dfdfdf;
}
.letterBox[state="countMatch"]{
  color: #eaff00;
}
.letterBox[state="typeMatch"]{
  color: #0066ff;
}
.letterBox[state="exactMatch"]{
  color: #00ce2d;
}

.letter{
  flex: 1 0 50px;
  /*
  outline-style: dashed;
  outline-width: 1px;
  */
  width: -moz-fit-content;
  width: fit-content;
}

.matches{
  color: #acacac;
  font-size: 0.7rem;
  font-weight: 1;
  flex: 0 1 1px
}
.keyboard{
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.keyboardRow{
  display: flex;
  flex-direction: row;
  align-items: center;
}

.keyboardKeyLetter{
  background-color:#414141;
  margin: 2px;
  padding: 1px 5px 1px 5px;
  min-width: 25px;
  max-width: 50px;
  min-height: 35px;
  line-height: 2;
  text-align:center;
  align-self: center;
  color: white;
  border-radius: 7px;
  -webkit-user-select: none;
          user-select: none;
  outline-style: inset;
  outline-width: 2px;
}

.keyboardKeyLetter:hover{
  cursor: pointer
}

.keyboardKeyLetter[highlight='on']{
  outline-style: inset;
  outline-color: #eaff00;
  outline-width: 2px;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,uBAAuB;EACvB,4DAAuD;EACvD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;;EAEjB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB;;;;;GAKC;AACH;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;;;;;CAMC;;;AAGD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,uCAAuC;EACvC,8BAA8B;EAC9B,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;;EAEtB,wBAAwB;EACxB,yBAAyB;EACzB,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd;;;GAGC;EACD,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd;AACF;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;AACF;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["\n@font-face{\n  font-family: 'Storkdle';\n  src: url('/public/Comme-Regular.woff2') format('woff2');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.App {\n  text-align: center;\n  background-color: #3b3b3b;\n  font-family: 'Storkdle', sans-serif;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.word{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  \n  height: 60px;\n  user-select: none;\n  /*\n  background-color: #61dafb;\n  border-style: double;\n  border-width: 1px;\n  margin: 5px;\n  */\n}\n\n@keyframes bounce {\n  from{ \n    max-height: 50px;\n  }\n  to{\n    max-height: 0px;\n  }\n}\n\n.letterBox {\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap;\n  font-size: 1.5rem;\n  font-weight: 5;\n  text-align: center;\n  text-transform: uppercase;\n  align-items: center;\n  justify-content: center;\n  margin-right: 5px;\n  margin-left: 5px;\n  max-width: 50px;\n  max-height: 50px;\n  aspect-ratio: 1;\n  position:relative;\n\n  outline-width: 1px;\n  outline-style: solid;\n  color: #131313;\n  background: #e7edf3;\n/*\n  animation-name: bounce;\n  animation-iteration-count: infinite;\n  animation-duration: 2s;\n  animation-direction: normal;\n  animation-timing-function: linear;\n*/\n\n\n}\n\n@keyframes popScale {\n  from{\n    scale: 1.0;\n  }\n  to{\n    scale: 1.1;\n  }\n}\n\n@keyframes onInvalidWord {\n  from{\n    background: #e7edf3;\n    color: #131313;\n  }\n  to{\n    background: #9c0000;\n    color: #c3c3c3;\n  }\n}\n@keyframes onGuess {\n  from{\n    font-size: 0rem;\n  }\n  to{\n    font-size: 1.5rem;\n  }\n}\n\n.letterBox[state='invalid']{\n  color: #c3c3c3;\n  background: #9c0000;\n  outline-color: #212121;\n  animation-name: popScale, onInvalidWord;\n  animation-duration: 0.1s, 0.1s;\n  animation-direction: alternate-reverse, normal;\n  animation-iteration-count: 1, 1;\n}\n\n.letterBox[state=\"valid\"]{\n  color: #131313;\n  background: #e7edf3;\n  outline-color: #212121;\n\n  animation-name: popScale;\n  animation-duration: 0.05s;\n  animation-direction: alternate-reverse;\n  animation-iteration-count: 1;\n}\n.letterBox[state=\"incomplete\"]{\n  color: #131313;\n  background: #e7edf3;\n  outline-color: #acacac;\n}\n.letterBox[state=\"unused\"]{\n  color: #131313;\n  background: #e7edf3;\n  outline-color: #acacac;\n}\n\n\n.letterBox[type=\"result\"]{\n  background: #414141;\n  animation-name: bounce, onGuess;\n  animation-duration: 0.1s, 0.1s;\n  animation-direction: alternate-reverse, normal;\n  animation-iteration-count: 1, 1;\n}\n\n.letterBox[state=\"noMatch\"]{\n  color: #dfdfdf;\n}\n.letterBox[state=\"countMatch\"]{\n  color: #eaff00;\n}\n.letterBox[state=\"typeMatch\"]{\n  color: #0066ff;\n}\n.letterBox[state=\"exactMatch\"]{\n  color: #00ce2d;\n}\n\n.letter{\n  flex: 1 0 50px;\n  /*\n  outline-style: dashed;\n  outline-width: 1px;\n  */\n  width: fit-content;\n}\n\n.matches{\n  color: #acacac;\n  font-size: 0.7rem;\n  font-weight: 1;\n  flex: 0 1 1px\n}\n.keyboard{\n  margin-top: 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.keyboardRow{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.keyboardKeyLetter{\n  background-color:#414141;\n  margin: 2px;\n  padding: 1px 5px 1px 5px;\n  min-width: 25px;\n  max-width: 50px;\n  min-height: 35px;\n  line-height: 2;\n  text-align:center;\n  align-self: center;\n  color: white;\n  border-radius: 7px;\n  user-select: none;\n  outline-style: inset;\n  outline-width: 2px;\n}\n\n.keyboardKeyLetter:hover{\n  cursor: pointer\n}\n\n.keyboardKeyLetter[highlight='on']{\n  outline-style: inset;\n  outline-color: #eaff00;\n  outline-width: 2px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
